<template lang="pug">
.historico-operacao-trigger
    i.el-icon-time.historico-operacao-trigger__icone(
        @click='abrirHistorico()'
    )
        span.historico-operacao-trigger__icone-texto {{ $t('mensagens.operacao.visualizar.historico.icone') }}

    ModalVisualizarHistorico(
        :idOperacao='idOperacao'
        :mostrar='mostrarModalVisualizarHistorico'
        @fechar='mostrarModalVisualizarHistorico = false'
    )
</template>

<script>
import ModalVisualizarHistorico from '@/components/operacao/gestao/ModalVisualizarHistorico.vue';

export default {
    name: 'ModalHistoricoOperacao',
    components: {
        ModalVisualizarHistorico
    },
    props: {
        idOperacao: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            mostrarModalVisualizarHistorico: false
        };
    },
    methods: {
        abrirHistorico() {
            this.mostrarModalVisualizarHistorico = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.historico-operacao-trigger {
    text-align: right;
    vertical-align: middle;
    color: var(--primary);

    .historico-operacao-trigger__icone {
        cursor: pointer;
        font-size: 17px;
    }

    .historico-operacao-trigger__icone-texto {
        margin-left: 2px;
        font-family: "Roboto", sans-serif !important;
        font-size: 15px;
    }
}
</style>
